import { RSA_PUBLIC_KEY } from "../constant/app.constant";
import forge from "node-forge";

export default class RSAencryption {
  static EnctyptString(secretString) {
    if(!!!secretString) return "";
    let result = "";
    var pki = forge.pki;
    var publicKey = pki.publicKeyFromPem(this.decryptDataByATOB(RSA_PUBLIC_KEY, true));
    if(secretString.length > 50) {
      for (let i = 0; i < secretString.length; i = i + 50) {
        const substring = secretString.slice(i, i + 50);
        const encryptedString = publicKey.encrypt(substring, "RSA-OAEP");
        result = !!result ? result + "," + forge.util.encode64(encryptedString) : forge.util.encode64(encryptedString);
      }
    } else {
      const encryptedString = publicKey.encrypt(secretString, "RSA-OAEP");
      result = forge.util.encode64(encryptedString);
    };
    return result;
  }

  //NOTE:Apple Token Decode
  static AppleTokenDecode(token_id) {
    return token_id;
  }

  static encryptDataByBTOA(data) {
    try {
      return btoa(JSON.stringify(data));
    } catch (error) {
      return data;
    }
  }

  static decryptDataByATOB(data, returnString = false) {
    try {
      return returnString ? atob(data) : JSON.parse(atob(data));
    } catch (error) {
      return data;
    }
  }
}
